import { Search, X } from "lucide-react";

/**
 * Modal that lists all 114 surahs with a search filter.
 * Selecting a surah triggers `onSelect(surahNum)`.
 */
export default function SurahSelector({
  open,
  filteredSurahs,
  surahSearch,
  setSurahSearch,
  currentSurahNumber,
  onClose,
  onSelect,
}) {
  if (!open) return null;

  return (
    <div
      data-testid="surah-selector-modal"
      className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-start justify-center pt-16 px-4"
    >
      <div className="w-full max-w-lg bg-islamic-blue-900 rounded-2xl shadow-2xl border border-white/10 max-h-[80vh] flex flex-col">
        {/* Modal Header */}
        <div className="p-4 border-b border-white/10">
          <div className="flex items-center justify-between mb-3">
            <h2 className="font-cinzel text-lg text-slate-100">Select Surah</h2>
            <button
              data-testid="surah-selector-close-btn"
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-slate-400 hover:text-slate-200"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          {/* Search Input */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <input
              data-testid="surah-search-input"
              type="text"
              placeholder="Search by name or number..."
              value={surahSearch}
              onChange={(e) => setSurahSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 bg-islamic-blue-950/50 border border-white/10 rounded-lg text-slate-200 placeholder:text-slate-600 focus:outline-none focus:border-gold-400/50"
              autoFocus
            />
          </div>
        </div>

        {/* Surah List */}
        <div className="flex-1 overflow-y-auto p-2">
          {filteredSurahs.map((s) => (
            <button
              key={s.number}
              data-testid={`surah-option-${s.number}`}
              onClick={() => onSelect(s.number)}
              className={`w-full flex items-center gap-3 p-3 rounded-xl transition-all hover:bg-gold-400/10 ${
                currentSurahNumber === s.number ? "bg-gold-400/20 border border-gold-400/30" : ""
              }`}
            >
              <span className="w-10 h-10 rounded-full bg-gold-400/10 flex items-center justify-center text-gold-400 font-outfit font-medium text-sm">
                {s.number}
              </span>
              <div className="flex-1 text-left">
                <div className="flex items-center gap-2">
                  <span className="text-slate-100 font-outfit">{s.englishName}</span>
                  <span className="text-slate-500 text-xs">({s.ayahs} ayahs)</span>
                </div>
                <span className="font-amiri text-gold-400/80 text-sm">{s.name}</span>
              </div>
              <span className="text-xs text-slate-500 font-outfit">{s.type}</span>
            </button>
          ))}
          {filteredSurahs.length === 0 && (
            <p className="text-center text-slate-500 font-outfit py-8">No surahs found</p>
          )}
        </div>
      </div>
    </div>
  );
}
